'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var OriginBigNumber = require('bignumber.js');

function _interopDefault (e) { return e && e.__esModule ? e : { default: e }; }

var OriginBigNumber__default = /*#__PURE__*/_interopDefault(OriginBigNumber);

const BigNumber = OriginBigNumber__default.default.clone({ STRICT: true });

exports.default = BigNumber;
//# sourceMappingURL=bignumber.js.map
